import { createActions } from 'redux-actions';
import { HealthClaim } from '@models/HealthClaim';
import { InsurancePolicy } from '@models/InsurancePolicy';
import { CreateHealthClaimParams } from '@apis/HealthClaimApi';
import { GetInsurancePolicyParams } from '@apis/InsurancePolicyApi';
import { InsurancePolicyUser } from '@models/InsurancePolicyUser';

export type State = {
  serverErrors: object;
  policy?: InsurancePolicy | null;
  insurancePolicyUser?: InsurancePolicyUser | null;
  healthClaim?: HealthClaim | null;
};
export type StateUpdatePayload = Partial<State>;
export type PolicyFetchPayload = GetInsurancePolicyParams;
export type InsurancePolicyUserFetchPayload = { id: number };
export type HealthClaimCreatePayload = CreateHealthClaimParams;

export const {
  policyFetch,
  insurancePolicyUserFetch,
  healthClaimCreate,

  stateUpdate,
} = createActions(
  'POLICY_FETCH',
  'INSURANCE_POLICY_USER_FETCH',
  'HEALTH_CLAIM_CREATE',

  'STATE_UPDATE',
  {
    prefix: 'USER_DASHBOARD_POLICY_CLAIM_HEALTH_POLICY_CLAIM',
  },
);
